export default __webpack_public_path__ + "2960900c4f271311eb36d175a209aa0a.woff2";